import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Atto } from 'src/app/common/models/atto';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';
import { stepMap } from '../../creazione-pratica-stepper/config/step';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { ConfigurationUtilService } from 'src/app/core/services/configuration-util-service';

@Component({
  selector: 'atti-list-view',
  templateUrl: './atti-list-view.component.html',
  styleUrls: ['./atti-list-view.component.css']
})
export class AttiListViewComponent implements OnInit {


  @Input() atti: Atto[] = [];
  @Input() hasDeleteButton: boolean;
  @Input() hasEditButton: boolean;
  @Input() hasAssociaButton: boolean;
  @Input() associaDisabled: boolean;
  @Input() fascicolo;
  @Input() sezione;
  @Output() deleteEvent: EventEmitter<{atto: Atto, index: number}> = new EventEmitter<{atto: Atto, index: number}>();
  @Output() editEvent: EventEmitter<number> = new EventEmitter<number>();
  @Output() saveNewAttoEvent: EventEmitter<Atto> = new EventEmitter<Atto>();
  @Output() associaEvent: EventEmitter<Atto> = new EventEmitter<Atto>();
  @Output() onDropDownEvent: EventEmitter<DropDownEvent> = new EventEmitter<DropDownEvent>();
  @Output() onDocumentEvent: EventEmitter<DocumentEvent> = new EventEmitter<DocumentEvent>();
  activeIndex: number;
  accordions = stepMap;
  writable: boolean;

  constructor(private viewManager: ViewManagerService, private configurationUtil: ConfigurationUtilService) { 
    this.configurationUtil.descrittoriMap.subscribe(descrittore => {
      if(descrittore) {
        this.writable = descrittore[NomiDescrittoriSezione.SEZIONE_ATTI_FASCICOLO].writable
      }
    })
  }

  ngOnInit() {
  }


  onDelete(props: {atto: Atto, index: number}) {
    this.deleteEvent.emit(props);
  }

  onEdit(index: number) {
    this.editEvent.emit(index);
  }

  onSave(atto: Atto) {
    this.saveNewAttoEvent.emit(atto);
  }

  onAssocia(i: number) {
    this.associaEvent.emit(this.atti[i]);
  }

  openDetail(atto: Atto, indice: number) {
    if (this.activeIndex === undefined || this.activeIndex !== indice) {
      this.activeIndex = indice;
    } else {
      this.activeIndex = undefined;
    }
  }

  onClickDropDownEvent(event: DropDownEvent) {
    this.onDropDownEvent.emit(event);
  }

  // documento

  onReturnUpdateCallback(event) {
    this.onDocumentEvent.emit(
      {
        documento: event,
        eventType:  'modifica'
      }
    )
  }

  showUploadNewVersionModal(documento: DocumentoAllegato) {
    this.onDocumentEvent.emit(
      {
        documento: documento,
        eventType:  'nuova-versione'
      }
    )
  }

  showHistoryModal(documento: DocumentoAllegato) {
    this.onDocumentEvent.emit(
      {
        documento: documento,
        eventType:  'storico'
      }
    )
  }

  removeDoc(documento: DocumentoAllegato, entityId: string, sezioneId: string) {
    this.onDocumentEvent.emit(
      {
        documento: documento,
        entityId: entityId,
        sezioneId: sezioneId,
        eventType:  'elimina'
      }
    )
  }

  displayDocUpdateMetadatiModal(documento: DocumentoAllegato) {
    this.onDocumentEvent.emit(
      {
        documento: documento,
        eventType:  'metadati'
      }
    )
  }

}

type DropDownEvent = {
  atto: Atto,
  eventType: 'allegato' | 'elimina',
  index: number
}

type DocumentEvent = {
  documento: DocumentoAllegato,
  atto?: Atto,
  entityId?: string,
  sezioneId?: string,
  eventType: 'nuova-versione' | 'storico' | 'modifica' | 'elimina' | 'metadati'
}
